"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrintables = exports.getProjectVersions = exports.getV1Project = exports.getProject = exports.getAllProjects = exports.createProject = exports.updateProjectQuantity = exports.updateProjectStatus = exports.restoreProject = exports.updateProjectName = exports.deleteProject = exports.duplicateProject = exports.redoProject = exports.undoProject = void 0;
const specificProjectAction_1 = __importDefault(require("./specificProjectAction"));
const syncProject_1 = __importDefault(require("./syncProject"));
const undoProject = (flashId, flashToken, projectId, projectVersion) => __awaiter(void 0, void 0, void 0, function* () {
  return (0, specificProjectAction_1.default)(flashId, flashToken, projectId, 'patch', 'undo', {
    version: projectVersion
  });
});
exports.undoProject = undoProject;
const redoProject = (flashId, flashToken, projectId, projectVersion) => __awaiter(void 0, void 0, void 0, function* () {
  return (0, specificProjectAction_1.default)(flashId, flashToken, projectId, 'patch', 'redo', {
    version: projectVersion
  });
});
exports.redoProject = redoProject;
const duplicateProject = (flashId, flashToken, projectId) => __awaiter(void 0, void 0, void 0, function* () {
  return (0, specificProjectAction_1.default)(flashId, flashToken, projectId, 'post', 'duplicate');
});
exports.duplicateProject = duplicateProject;
const deleteProject = (flashId, flashToken, projectId) => __awaiter(void 0, void 0, void 0, function* () {
  return (0, specificProjectAction_1.default)(flashId, flashToken, projectId, 'delete');
});
exports.deleteProject = deleteProject;
const updateProjectName = function (flashId_1, flashToken_1, projectId_1, newProjectName_1) {
  for (var _len = arguments.length, args_1 = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
    args_1[_key - 4] = arguments[_key];
  }
  return __awaiter(void 0, [flashId_1, flashToken_1, projectId_1, newProjectName_1, ...args_1], void 0, function (flashId, flashToken, projectId, newProjectName) {
    let skipVersionIncrement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return function* () {
      const date = new Date();
      const timestamp = date.toISOString();
      const updateProjectNameProjectAction = {
        type: 'UPDATE_PROJECT_NAME',
        projectId: projectId,
        name: newProjectName,
        skipVersionIncrement,
        timestamp
      };
      return (0, syncProject_1.default)(flashId, flashToken, projectId, [updateProjectNameProjectAction]);
    }();
  });
};
exports.updateProjectName = updateProjectName;
const restoreProject = (flashId, flashToken, projectId) => __awaiter(void 0, void 0, void 0, function* () {
  const date = new Date();
  const timestamp = date.toISOString();
  const updateProjectMarkedForDeletion = [{
    type: 'UPDATE_PROJECT_MARKED_FOR_DELETION',
    markedForDeletion: false,
    projectId: projectId,
    timestamp
  }];
  return (0, syncProject_1.default)(flashId, flashToken, projectId, updateProjectMarkedForDeletion);
});
exports.restoreProject = restoreProject;
const updateProjectStatus = (flashId, flashToken, projectId, status) => __awaiter(void 0, void 0, void 0, function* () {
  const date = new Date();
  const timestamp = date.toISOString();
  const updateStatus = [{
    type: 'UPDATE_PROJECT_STATUS',
    status: status,
    projectId: projectId,
    timestamp
  }];
  return (0, syncProject_1.default)(flashId, flashToken, projectId, updateStatus);
});
exports.updateProjectStatus = updateProjectStatus;
const updateProjectQuantity = (flashId, flashToken, projectId, qty) => __awaiter(void 0, void 0, void 0, function* () {
  const date = new Date();
  const timestamp = date.toISOString();
  const updateStatus = [{
    type: 'UPDATE_PROJECT_QUANTITY',
    qty,
    projectId,
    timestamp
  }];
  return (0, syncProject_1.default)(flashId, flashToken, projectId, updateStatus);
});
exports.updateProjectQuantity = updateProjectQuantity;
var createProject_1 = require("./createProject");
Object.defineProperty(exports, "createProject", {
  enumerable: true,
  get: function () {
    return __importDefault(createProject_1).default;
  }
});
var getAllProjects_1 = require("./getAllProjects");
Object.defineProperty(exports, "getAllProjects", {
  enumerable: true,
  get: function () {
    return __importDefault(getAllProjects_1).default;
  }
});
var getProject_1 = require("./getProject");
Object.defineProperty(exports, "getProject", {
  enumerable: true,
  get: function () {
    return __importDefault(getProject_1).default;
  }
});
var getV1Project_1 = require("./getV1Project");
Object.defineProperty(exports, "getV1Project", {
  enumerable: true,
  get: function () {
    return __importDefault(getV1Project_1).default;
  }
});
var getProjectVersions_1 = require("./getProjectVersions");
Object.defineProperty(exports, "getProjectVersions", {
  enumerable: true,
  get: function () {
    return __importDefault(getProjectVersions_1).default;
  }
});
var getPrintables_1 = require("./getPrintables");
Object.defineProperty(exports, "getPrintables", {
  enumerable: true,
  get: function () {
    return __importDefault(getPrintables_1).default;
  }
});